import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowLeft } from 'lucide-react';
import type { Serie } from '@/types/masterclass';

interface SerieHeaderProps {
  serie: Serie;
  progressoPct: number;
  onBack: () => void;
}

export function SerieHeader({ serie, progressoPct, onBack }: SerieHeaderProps) {
  useLanguage();
  return (
    <header 
      className="sticky top-0 z-30 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b"
      aria-label={translateInterfaceText("Navegação da série")}
    >
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        {/* Esquerda: Voltar + Título */}
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            size="sm"
            onClick={onBack}
            className="gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            <span className="hidden sm:inline">{translateInterfaceText("Master Class")}</span>
          </Button>

          <div className="flex items-center gap-2">
            <h1 className="text-base sm:text-lg font-semibold line-clamp-1">
              {serie.titulo}
            </h1>
            <Badge variant="outline" className="text-xs">
              {serie.nivel}
            </Badge>
          </div>
        </div>

        {/* Direita: Progresso */}
        {progressoPct > 0 && (
          <div className="hidden sm:flex items-center gap-2 text-sm text-muted-foreground">
            <span className="font-medium">{progressoPct}%</span>
            <span>{translateInterfaceText("concluído")}</span>
          </div>
        )}
      </div>
    </header>
  );
}
